/* eslint-disable import/no-anonymous-default-export */
import {
  FETCH_CLIENT_LIST,
  CLIENT_LOADING,
  RESET_CLIENTS_LIST,
  CLIENT_ERROR,
  LOGOUT,
  CLIENT_APP_DATA_LOADING,
  SET_CLIENT_PROFILE,
  GET_CLIENT_TOOLS_SUCCESS,
  CLEAR_CLIENT_PROFILE,
  GET_TOOL_TYPE_SUCCESS,
  ALL_TOOL_SUCCESS,
  VIEW_TOOL_SUCCESS,
  CUSTOM_JOURNAL_QUESTION_SUCCESS,
  SHORTCUT_LISTING_SUCCESS,
  SHORTCUT_SEARCH_SUCCESS,
  ASSIGN_TOOL_SUCCESS,
  COMPLETED_ASSESSMENTS_SUCCESS,
  PRO_ASSESSMENT_SUCCESS,
  ASSIGNED_ASSESSMENTS_SUCCESS,
  UNASSIGNED_ASSESSMENTS_SUCCESS,
  ASSESSMENT_FOR_PSYCHIATRIST_SUCCESS,
  ASSESSMENT_DETAIL_SUCCESS,
  ASSESSMENT_RESULT_SUCCESS,
  CLEAR_TIMELINE_TOOLS_SUCCESS,
  CLEAR_VIEW_TOOL,
  FIRST_SESSION,
  GET_TIMELINE_TOOLS_SUCCESS,
  LOAD_SESSION_ON_CLIENTS,
  CHAT_CLIENT_LIST_LOADING,
  CLIENT_LIST_LOADING,
  CLIENT_PROFILE_LOADING,
  CHAT_CLIENT_LIST,
  SET_CLIENT_CHAT,
  UPDATE_CLIENT_CHAT_ROOM_UNREAD_COUNT,
  SET_TREATMENT_PLAN_DISABLED_STATUS,
  SET_TREATMENT_PLAN_SEND_STATUS,
  SET_VERIFYING_NSP,
  SET_SELECTED_NOTE_META,
  CLEAR_SELECTED_NOTE_META,
} from "../Actions/types";

const INITIAL_STATE = {
  clientList: [],
  error: "",
  loading: true,
  clientListLoading: false,
  clientProfileLoading: false,
  clientAppDataLoading: false,
  clientProfile: {},
  clientChat: { loading: true, data: null, error: "" },
  assessments: {},
  totalPages: 0,
  loadingChatClientList: true,
  chatClientList: [],
  disableTreatmentPlan: null,
  sendingTreatmentPlan: false,
  verifyingNsp: false,
  selectedNoteMeta: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_CLIENT_LIST:
      return {
        ...state,
        clientList: [...state.clientList, ...action.payload.data],
        totalPages: action.payload.totalPages,
        loading: false,
        error: "",
      };
    case CLIENT_LOADING: {
      return { ...state, loading: action.payload };
    }
    case CLIENT_LIST_LOADING: {
      return { ...state, clientListLoading: action.payload };
    }
    case CLIENT_PROFILE_LOADING: {
      return { ...state, clientProfileLoading: action.payload };
    }
    case SET_VERIFYING_NSP: {
      return { ...state, verifyingNsp: action.payload };
    }
    case RESET_CLIENTS_LIST:
      return {
        ...state,
        clientList: [],
        totalPages: 0,
        loading: false,
      };

    case SET_CLIENT_CHAT:
      return { ...state, clientChat: action.payload };
    case CHAT_CLIENT_LIST_LOADING: {
      return { ...state, loadingChatClientList: action.payload };
    }
    case CHAT_CLIENT_LIST: {
      return {
        ...state,
        chatClientList: action.payload.data,
        loadingChatClientList: false,
      };
    }

    case CLIENT_ERROR:
      return { ...state, error: action.payload, loading: false };
    case CLIENT_APP_DATA_LOADING:
      return { ...state, clientAppDataLoading: action.payload };
    case SET_CLIENT_PROFILE:
      return {
        ...state,
        clientProfile: {
          ...state.clientProfile,
          ...action.payload,
        },
        clientAppDataLoading: false,
        loading: false,
      };
    case UPDATE_CLIENT_CHAT_ROOM_UNREAD_COUNT: {
      const roomId = action.payload.roomId;
      const chatRoomDetails = state.clientProfile?.chat_room_details || [];
      const hasMatchingRoom = chatRoomDetails.some(room => room.id === roomId);

      if (!hasMatchingRoom) return state;

      return {
        ...state,
        clientProfile: {
          ...state.clientProfile,
          chat_room_details: chatRoomDetails.map(room =>
            room.id === roomId
              ? {
                  ...room,
                  unread_count: action.payload.unreadCount,
                }
              : room
          ),
        },
      };
    }
    case CLEAR_CLIENT_PROFILE:
      return { ...state, clientProfile: {}, clientAppDataLoading: false };
    case GET_CLIENT_TOOLS_SUCCESS:
      return { ...state, generalTools: action.payload };
    case GET_TIMELINE_TOOLS_SUCCESS:
      return { ...state, timelineTools: action.payload };
    case CLEAR_TIMELINE_TOOLS_SUCCESS:
      return { ...state, timelineTools: [] };
    case GET_TOOL_TYPE_SUCCESS:
      return { ...state, toolMediaType: action.payload };
    case ALL_TOOL_SUCCESS:
      return { ...state, allTools: action.payload };
    case VIEW_TOOL_SUCCESS:
      return { ...state, currentToolView: action.payload.data };
    case CLEAR_VIEW_TOOL:
      return { ...state, currentToolView: {} };
    case CUSTOM_JOURNAL_QUESTION_SUCCESS:
      return { ...state, customJournalQuestion: action.payload.data };
    case ASSIGN_TOOL_SUCCESS:
      return { ...state, assignedTool: action.payload };
    case FIRST_SESSION:
      return { ...state, firstSession: action.payload };
    case SET_TREATMENT_PLAN_DISABLED_STATUS:
      return { ...state, disableTreatmentPlan: action.payload };
    case SET_TREATMENT_PLAN_SEND_STATUS:
      return { ...state, sendingTreatmentPlan: action.payload };

    case LOAD_SESSION_ON_CLIENTS:
      return { ...state, loadSession: action.payload };
    case SHORTCUT_LISTING_SUCCESS:
    case SHORTCUT_SEARCH_SUCCESS:
      return { ...state, shortCuts: action.payload.data };

    case ASSESSMENT_FOR_PSYCHIATRIST_SUCCESS:
      return {
        ...state,
        assessments: {
          ...state.assessments,
          assessmentForPsychiatrist: action.payload,
        },
        loading: false,
      };
    case PRO_ASSESSMENT_SUCCESS:
      return {
        ...state,
        assessments: { ...state.assessments, pro: action.payload },
        loading: false,
      };
    case COMPLETED_ASSESSMENTS_SUCCESS:
      return {
        ...state,
        assessments: {
          ...state.assessments,
          completed: !action.payload.completedAssessments
            ? []
            : action.payload.completedAssessments,
          initial_assessment_taken: action.payload.initial_assessment_taken,
          initial_assessment: action.payload.initial_assessment,
        },
        loading: false,
      };
    case ASSIGNED_ASSESSMENTS_SUCCESS:
      return {
        ...state,
        assessments: {
          ...state.assessments,
          assigned: !action.payload ? [] : action.payload,
        },
        loading: false,
      };
    case UNASSIGNED_ASSESSMENTS_SUCCESS:
      return {
        ...state,
        assessments: {
          ...state.assessments,
          unassigned: !action.payload ? [] : action.payload,
        },
        loading: false,
      };
    case ASSESSMENT_DETAIL_SUCCESS:
      return {
        ...state,
        assessments: {
          ...state.assessments,
          assessmentDetails: action.payload,
        },
        loading: false,
      };
    case ASSESSMENT_RESULT_SUCCESS:
      return {
        ...state,
        assessments: {
          ...state.assessments,
          assessmentResults: action.payload,
        },
        loading: false,
      };
    // Store metadata for the currently selected note (noteFor, noteCategory, isGroupNote)
    // This avoids passing complex data through URL params which causes encoding issues
    case SET_SELECTED_NOTE_META:
      return { ...state, selectedNoteMeta: action.payload };
    // Clear note metadata when modal is closed to keep Redux state clean
    case CLEAR_SELECTED_NOTE_META:
      return { ...state, selectedNoteMeta: null };
    case LOGOUT:
      return INITIAL_STATE;
    default:
      return state;
  }
};
